import { createContext } from 'react';

export type ErrorContextType = {
  error: { message: string; source: string } | null;
  setError: (error: { message: string; source: string }) => void;
};

export const ErrorContext = createContext<ErrorContextType | undefined>(
  undefined,
);
